<script setup lang="ts">
import { ref, computed } from "vue";
import { asyncComputed } from '@vueuse/core'
import { useTranslation } from "i18next-vue";

import type { TabItem } from "@/types/ui";

import { getIconName } from "@/mixins/icon";

import TabMenu from "@/components/ui/TabMenu.vue";
import EditMacroSettings from "@/components/macro/EditMacroSettings.vue";
import EditMacroSequence from "@/components/macro/EditMacroSequence.vue";

const { t } = useTranslation();

const props = defineProps({
  macro_id: {
    type: String,
    required: true,
  },
});

const defaultTabItem = {
  icon: 'fa-light fa-gear',
  label: t('macro.tab.settings'),
  value: 'settings',
}

const tabItems = asyncComputed(async() => {
  const iconList = await getIconName('fa-list-timeline');
  
  return [
    {
      icon: 'fa-light fa-gear',
      label: t('macro.tab.settings'),
      value: 'settings',
    },
    {
      icon: `fa-light ${iconList}`,
      label: t('macro.tab.sequence'),
      value: 'sequence',
    },
  ]
});

const animationClass = ref('');
const activeTab = ref<TabItem>(defaultTabItem);
const slideRight = ref(false);

const tabTransition = computed(() => {
  return slideRight.value == true ? 'slide-tab-right' : 'slide-tab-left';
});

function goTo(item: TabItem) {
  const activeTabIndex = tabItems.value.findIndex(i => i.value == activeTab.value.value);
  const newTabIndex = tabItems.value.findIndex(i => i.value == item.value);
  slideRight.value = newTabIndex < activeTabIndex ? true : false;
  activeTab.value = item;
}

</script>
<template>
  <Suspense>
    <div class="page-edit-macro">
      <div class="page-edit-macro__navbar">
        <TabMenu
          v-if="tabItems"
          @item-click="goTo"
          :list-data="tabItems"
          :active-tab="activeTab"
        />
      </div>
      <div class="page-edit-macro__main" :class="animationClass">
        <div class="page-edit-macro__tabs">
          <Transition :name="tabTransition">
            <div v-show="activeTab.value == 'settings'" class="page-edit-macro__tab">
              <EditMacroSettings
                :macro-id="macro_id"
              />
            </div>
          </Transition>
          <Transition :name="tabTransition">
            <div v-show="activeTab.value == 'sequence'" class="page-edit-macro__tab">
              <EditMacroSequence
                :macro-id="macro_id"
                :active="activeTab.value == 'sequence'"
              />
            </div>
          </Transition>
        </div>
      </div>
    </div>
  </Suspense>
</template>
